export interface OnboardingStageColor {
  id: string;
  hex: string;
}

export const ONBOARDING_STAGE_COLORS: OnboardingStageColor[] = [
  { id: "blue", hex: "#3366FF" },
  { id: "teal", hex: "#33BBFF" },
  { id: "purple", hex: "#5F50FF" },
  { id: "pink", hex: "#EE38D0" },
  { id: "gold", hex: "#EC9D16" },
  { id: "green", hex: "#0CC675" },
  { id: "lime", hex: "#CCE329" },
  { id: "turquoise", hex: "#35B0A5" }
];

export const DEFAULT_ONBOARDING_STAGE_COLOR = ONBOARDING_STAGE_COLORS[0].hex;

export const getOnboardingStageColor = (color: string | undefined): string =>
  color || DEFAULT_ONBOARDING_STAGE_COLOR;

const ONBOARDING_STAGE_BADGE_CLASSES: Record<string, string> = {
  "#3366ff": "bg-surface-tags-blue border-tags-blue",
  "#33bbff": "bg-surface-tags-teal border-tags-teal",
  "#5f50ff": "bg-surface-tags-purple border-tags-purple",
  "#ee38d0": "bg-surface-tags-pink border-tags-pink",
  "#ec9d16": "bg-surface-tags-gold border-tags-gold",
  "#0cc675": "bg-surface-tags-green border-tags-green",
  "#cce329": "bg-surface-tags-lime border-tags-lime",
  "#35b0a5": "bg-surface-tags-turquoise border-tags-turquoise"
};

export const getOnboardingStageBadgeClassName = (
  color: string | null | undefined
): string =>
  ONBOARDING_STAGE_BADGE_CLASSES[
    getOnboardingStageColor(color ?? undefined).toLowerCase()
  ] ?? ONBOARDING_STAGE_BADGE_CLASSES[DEFAULT_ONBOARDING_STAGE_COLOR.toLowerCase()];
